<template>
  <div>
    <Router-View />
  </div>
</template>

<script>
export default {
  name: "MyBrandRoom",
};
</script>

<style></style>
